import { render } from "./options.vue?vue&type=template&id=36d5ea82"
import script from "./options.vue?vue&type=script&lang=js"
export * from "./options.vue?vue&type=script&lang=js"
script.render = render

export default script